import { Box, Button } from "@chakra-ui/react";
import { colors } from "goi_common";
import { useRouter } from "next/router";

interface NoResultProps {
  keyword: string;
}

export function NoResult({ keyword }: NoResultProps) {
  const router = useRouter();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding="110px 0"
    >
      <Box className="subtitle1_m gray500" marginBottom="24px" textAlign="center">
        <span className="orange700">{keyword}</span>에 대한
        <br />
        검색결과가 없습니다.
      </Box>
      <Button
        borderRadius="5px"
        bgColor={colors.black}
        color={colors.white}
        padding="10px 20px"
        onClick={() => router.push("/guidebook/search/")}
      >
        다시 둘러보기
      </Button>
    </Box>
  );
}
